import styled, { css } from 'styled-components';
import { COLORS } from './color';
import { rem } from '../../utils/style';

interface TableType {
  alignItems?: string;
  wrap?: boolean;
  maxWidth?: string;
}

interface TooltipComponentWrapperType {
  size: 'lg' | 'md' | 'sm';
  variant: 'dark' | 'light';
}

export const TableBodyCellColumn = styled.div<TableType>`
  text-align: 'left';
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props?.alignItems ?? ''};
  align-items: ${(props) => props?.alignItems ?? ''};
  row-gap: 4px;

  .cellTitle {
    line-height: ${rem(18)};
    display: block;
    gap: 4px;
    max-width: ${(props) => (props?.maxWidth ? props?.maxWidth : '225px')};
    white-space: ${(props) => (props?.wrap ? '' : 'nowrap')};
    /* white-space: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .cellSubtitle {
    font-size: ${rem(12)};
    font-weight: 500;
    line-height: ${rem(14)};
    color: ${COLORS.Gray};
  }
`;

export const TableBodyCellColumnCenter = styled.div<TableType>`
  text-align: center;
  max-width: ${(props) => (props?.maxWidth ? props?.maxWidth : '225px')};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellTooltipWrapper = styled.span`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

export const CellTooltipContent = styled.div<TooltipComponentWrapperType>`
  visibility: hidden;
  background: #222;
  color: #fff;
  text-align: left;
  border-radius: ${rem(4)};
  padding: ${rem(12)} ${rem(8)};
  position: absolute;
  z-index: 1001;
  left: 90%;
  top: 100%;
  min-width: ${rem(180)};
  transform: translateX(-50%);
  max-width: ${rem(320)};
  width: ${rem(320)};
  max-height: ${rem(180)};
  overflow: auto;
  white-space: wrap;
  // min-width: ${rem(120)};
  // width: max-content;
  // max-width: ${rem(500)};
  word-break: break-all;
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: auto;
  ${(props) => {
    if (props.variant === 'dark') {
      return css`
        background: ${COLORS.Black};

        span {
          color: ${COLORS.White};
        }
      `;
    }

    if (props.variant === 'light') {
      return css`
        background: ${COLORS.White};
      `;
    }
  }};

  ${(props) => {
    if (props.size === 'sm') {
      return css`
        padding: ${rem(10)} ${rem(11)};
      `;
    }

    if (props.size === 'md') {
      return css`
        padding: ${rem(12)} ${rem(8)};
      `;
    }

    if (props.size === 'lg') {
      return css`
        padding: ${rem(14)};
      `;
    }
  }};
`;

export const CellTooltipWrapperHover = styled(CellTooltipWrapper)`
  &:hover ${CellTooltipContent} {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
`;

// export const CellTooltipWrapperHover = styled.span`
//   position: relative;
//   display: inline-block;
//   cursor: pointer;

//   &:hover ${CellTooltipContent}, &:focus-within ${CellTooltipContent} {
//     visibility: visible;
//     opacity: 1;
//     pointer-events: auto;
//   }
// `;

// export const CellTooltipContent = styled.div`
//   /* ...existing styles... */
//   pointer-events: auto; // allow interaction
// `;
